const NOTE_MAX_LENGTH = 255;

export type ParsedEntryInput =
	| { ok: true; date: string; weight?: number; note?: string }
	| { ok: false; error: string };

// Shared validation for the quick-entry form and the per-day edit modal —
// both submit a date plus raw weight/note strings, and both need the same
// rules: a valid date, at least one of weight/note, and each well-formed on
// its own. Trims and drops an empty note to undefined so the caller can
// JSON.stringify the result directly (JSON.stringify omits undefined keys).
export function parseEntryInput(dateInput: string, weightInput: string, noteInput: string): ParsedEntryInput {
	if (!dateInput) return { ok: false, error: "Enter a valid date." };

	const note = noteInput.trim();
	const hasNote = note.length > 0;
	const hasWeightInput = weightInput.trim().length > 0;
	if (!hasWeightInput && !hasNote) {
		return { ok: false, error: "Enter a weight and/or a note." };
	}

	let weight: number | undefined;
	if (hasWeightInput) {
		weight = parseFloat(weightInput);
		if (Number.isNaN(weight) || weight <= 0) {
			return { ok: false, error: "Enter a valid weight." };
		}
	}

	if (hasNote && note.length > NOTE_MAX_LENGTH) {
		return { ok: false, error: `Note must be ${NOTE_MAX_LENGTH} characters or fewer.` };
	}

	return { ok: true, date: dateInput, weight, note: hasNote ? note : undefined };
}
